import { Layout, Typography } from "antd";
import { Outlet } from "react-router-dom";
import bowlTop from "../../assets/bowl-top.png";
import bowlRight from "../../assets/bowl-right.png";
import bottomLeft from "../../assets/bottom-left.png";
import logoWhite from "../../assets/logo-white.png";
import "./AuthLayout.css";

const { Content } = Layout;
const { Title, Text } = Typography;

export default function AuthLayout() {
  return (
    <Layout className="auth-layout">
      <Content className="auth-content">

        {/* LEFT SIDE */}
        <div className="auth-left">
          <Outlet />
        </div>

        {/* RIGHT PANEL */}
        <div className="auth-right">

          <img src={bowlTop} alt="" className="food-top" />
          <img src={bowlRight} alt="" className="food-right" />
          <img src={bottomLeft} alt="" className="food-bottom" />

          <div className="auth-brand">
            <img src={logoWhite} alt="Byondbites logo" className="auth-logo" />

            <Title level={3} className="auth-title">
              Byondbites Admin
            </Title>

            <Text className="auth-subtitle">
              Manage content and users
            </Text>
          </div>
        </div>
      </Content>
    </Layout>
  );
}
